<form class="flex flex-col gap-6" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="flex gap-6">
        <app-form-text
            class="flex-1"
            identifier="firstname"
            testId="students-add-firstname"
            [label]="'students.add.firstname.label' | translate"
            [placeholder]="'students.add.firstname.placeholder' | translate"
            [control]="form.controls.firstName"
        />
        <app-form-text
            class="flex-1"
            identifier="lastname"
            testId="students-add-lastname"
            [label]="'students.add.lastname.label' | translate"
            [placeholder]="'students.add.lastname.placeholder' | translate"
            [control]="form.controls.lastName"
        />
    </div>

    <app-form-text
        identifier="email"
        testId="students-add-email"
        [label]="'students.add.email.label' | translate"
        [placeholder]="'students.add.email.placeholder' | translate"
        [control]="form.controls.email"
    />

    <div>
        <legend>{{ 'label.role' | translate }}</legend>
        <div class="flex gap-4">
            <app-form-radio
                [control]="form.controls.role"
                value="teacher"
                [label]="'role.teacher' | translate"
                name="create.role"
                identifier="create.role"
                testId="students-add-role-teacher"
            />
            <app-form-radio
                [control]="form.controls.role"
                value="sna"
                [label]="'role.sna' | translate"
                name="create.role"
                identifier="create.role"
                testId="students-add-role-sna"
            />
            <app-form-radio
                [control]="form.controls.role"
                value="leader"
                [label]="'role.leader' | translate"
                name="create.role"
                identifier="create.role"
                testId="students-add-role-leader"
            />
        </div>
    </div>

    <!-- <app-form-text
        identifier="location"
        [label]="'students.add.location.label' | translate"
        [placeholder]="'students.add.location.placeholder' | translate"
        [control]="form.controls.location"
    /> -->

    <app-form-textarea
        identifier="description"
        testId="students-add-description"
        [label]="'students.add.description.label' | translate"
        [placeholder]="'students.add.description.placeholder' | translate"
        [control]="form.controls.description"
    />

    <app-form-submit [label]="'students.add.button' | translate" [disabled]="form.disabled" testId="students-add-submit" />
</form>
